"use client";

import { useState, useEffect } from "react";
import { X, CheckCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

interface SuccessMessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

export default function SuccessMessageModal({
  isOpen,
  onClose,
  message,
}: SuccessMessageModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="relative w-full max-w-md bg-white rounded-lg shadow-xl p-6"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={20} />
          </button>
          <div className="text-center">
            <div className="py-6 text-center">
              <div className="flex justify-center mb-4">
                <CheckCircle className="h-16 w-16 text-green-500" />
              </div>
              <h3 className="text-xl font-bold text-green-600 mb-2">
                {message}
              </h3>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
